"use client";

import { createContext, useContext } from "react";
import type { CarouselContextProps, CarouselContextProviderProps } from "./types/carousel.types";

// eslint-disable-next-line react-refresh/only-export-components -- exports context alongside provider
export const CarouselContext = createContext<CarouselContextProps>({
  activeId: "",
  loop: false,
});

export const CarouselProvider: React.FC<CarouselContextProviderProps> = (props) => {
  const { children, activeId, loop } = props;
  return <CarouselContext.Provider value={{ activeId, loop }}>{children}</CarouselContext.Provider>;
};

// eslint-disable-next-line react-refresh/only-export-components -- exports context alongside provider
export const useCarousel = () => useContext(CarouselContext);
